import React from "react";
import AIAcademyContent from "../FunctionComponents/AIAcademyFolder/AIAcademyContent";

function AIAcademy() {
  return (
    <>
      <AIAcademyContent />
    </>
  );
}

export default AIAcademy;
